__turbopack_context__.v({
  "wrpr": "CampaignBlock-module__Y9IB6a__wrpr",
});
